import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useTranslations } from "next-intl";

import { useConfiguration } from "~/contexts/configuration";
import Eva from "~/services/eva";
import CrossCountry from "~/types/cross-country";
import CommonUtils from "~/utils/common-utils";

import styles from "./product-detail-tags.module.scss";

type Props = {
  product: CrossCountry.DetailedProduct;
};

export default function ProductDetailTags(props: Props) {
  const t = useTranslations();
  const router = useRouter();
  const { organizationUnitId } = useConfiguration();

  const { data: discounts } = useQuery({
    queryKey: ["productDetailTags", props.product.product_id],
    staleTime: Infinity,
    queryFn: async () => {
      const eva = new Eva({ organizationUnitId, locale: router.locale });
      return await eva.getProductDiscounts(props.product.product_id.toString());
    },
    enabled: !!props.product.product_id,
  });

  const hasDiscounts = discounts && discounts?.length > 0;
  const hasCutPrice =
    CommonUtils.parseBoolean(process.env.NEXT_PUBLIC_ENABLE_SPECIAL_PROMO_LABEL) &&
    props.product.original_price !== undefined;

  if (!hasDiscounts && !hasCutPrice) {
    return null;
  }

  return (
    <div className={styles.tags}>
      {hasDiscounts &&
        discounts.map((tag) => (
          <div key={tag.DiscountID} className={styles.tag}>
            <p className={styles.label}>{tag.PromotionLabel}</p>
          </div>
        ))}
      {hasCutPrice && (
        <div className={styles.tag}>
          <p className={styles.label}>{t("generic.specialPromo")}</p>
        </div>
      )}
    </div>
  );
}
